import { styled, Box } from '@mui/material';

const StyledBox = styled(Box)({
  marginTop: 20,
  backgroundColor: 'white',
  width: 300,
  maxHeight: 200,
  overflow: 'auto',
  '& .MuiButton-root': {
    padding: '2px 8px',
    display: 'block',
    textAlign: 'left',
  },
});

export default StyledBox;
